var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProductLauch = function SvgProductLauch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m104 296c-4.418 0-8-3.582-8-8v-33.373c0-12.455-4.85-24.164-13.656-32.97-3.125-3.124-3.125-8.189-.001-11.314 3.125-3.124 8.19-3.124 11.313 0 11.829 11.828 18.344 27.555 18.344 44.284v33.373c0 4.418-3.582 8-8 8z",
    fill: "#faa037"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m64 176h-16v-24c0-4.418 3.582-8 8-8 4.418 0 8 3.582 8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m56 224c-4.418 0-8-3.582-8-8v-24h16v24c0 4.418-3.582 8-8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m64 192v-16h24c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16 184c0-4.418 3.582-8 8-8h24v16h-24c-4.418 0-8-3.582-8-8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m408 296c-4.418 0-8-3.582-8-8v-33.373c0-16.729 6.515-32.456 18.344-44.284 3.124-3.124 8.189-3.123 11.313 0 3.124 3.124 3.124 8.19-.001 11.314-8.806 8.806-13.656 20.515-13.656 32.97v33.373c0 4.418-3.582 8-8 8z",
    fill: "#faa037"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m296 280h-80c-4.418 0-8-3.582-8-8v-16h96v16c0 4.418-3.582 8-8 8z",
    fill: "#555a6e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m208 256h96v8h-96z",
    fill: "#463c4b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m304 264h-48v16h40c4.418 0 8-3.582 8-8z",
    fill: "#463c4b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m416 496h-320c-17.673 0-32-14.327-32-32v-176h384v176c0 17.673-14.327 32-32 32z",
    fill: "#c8733c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m224 496h-128c-17.673 0-32-14.327-32-32v-176h192v176c0 17.673-14.327 32-32 32z",
    fill: "#f0915a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 288c-17.673 0-32 14.327-32 32v32c0 4.418-3.582 8-8 8h-176c-4.418 0-8-3.582-8-8v-32c0-17.673 14.327-32 32-32z",
    fill: "#fab991"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 288c17.673 0 32 14.327 32 32v32c0 4.418 3.582 8 8 8h176c4.418 0 8-3.582 8-8v-32c0-17.673-14.327-32-32-32z",
    fill: "#f0915a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m304 256h-48v-240c10.245 0 20.07 4.07 27.314 11.314 23.49 23.49 36.686 55.349 36.686 88.568v124.118c0 8.837-7.163 16-16 16z",
    fill: "#a5c3dc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m208 256h48v-240c-10.245 0-20.07 4.07-27.314 11.314-23.49 23.49-36.686 55.349-36.686 88.568v124.118c0 8.837 7.163 16 16 16z",
    fill: "#d7e6f0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 120,
    fill: "#ff6e91",
    r: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m296 120c0-22.091-17.909-40-40-40v80c22.091 0 40-17.909 40-40z",
    fill: "#e64178"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 120,
    fill: "#00d2d2",
    r: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 176c-4.418 0-8 3.582-8 8v80c0 4.418 3.582 8 8 8 4.418 0 8-3.582 8-8v-80c0-4.418-3.582-8-8-8z",
    fill: "#ff6e91"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m320 240 28.686 28.686c2.122 2.122 4.999 3.314 8 3.314 6.248 0 11.314-5.065 11.314-11.314v-26.745c0-6.365-2.529-12.47-7.029-16.971l-40.971-40.97z",
    fill: "#e64178"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m192 240-28.686 28.686c-2.122 2.122-4.999 3.314-8 3.314-6.248 0-11.314-5.065-11.314-11.314v-26.745c0-6.365 2.529-12.47 7.029-16.971l40.971-40.97z",
    fill: "#ff6e91"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 16v32h-44.01c4.78-7.42 10.36-14.35 16.7-20.69 3.62-3.62 7.89-6.45 12.53-8.37s9.66-2.94 14.78-2.94z",
    fill: "#ff6e91"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m300.01 48h-44.01v-32c5.12 0 10.14 1.02 14.78 2.94s8.91 4.75 12.53 8.37c6.34 6.34 11.92 13.27 16.7 20.69z",
    fill: "#e64178"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m216 280h80v8h-80z",
    fill: "#00d2d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m448 176h16v-24c0-4.418-3.582-8-8-8-4.418 0-8 3.582-8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m456 224c4.418 0 8-3.582 8-8v-24h-16v24c0 4.418 3.582 8 8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m448 192v-16h-24c-4.418 0-8 3.582-8 8 0 4.418 3.582 8 8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m496 184c0-4.418-3.582-8-8-8h-24v16h24c4.418 0 8-3.582 8-8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m360 48h16v-16c0-4.418-3.582-8-8-8-4.418 0-8 3.582-8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m368 88c4.418 0 8-3.582 8-8v-16h-16v16c0 4.418 3.582 8 8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m360 64v-16h-16c-4.418 0-8 3.582-8 8 0 4.418 3.582 8 8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m400 56c0-4.418-3.582-8-8-8h-16v16h16c4.418 0 8-3.582 8-8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m368 168c-4.418 0-8-3.582-8-8v-48c0-4.418 3.582-8 8-8s8 3.582 8 8v48c0 4.418-3.582 8-8 8z",
    fill: "#faa037"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m368 200c-4.418 0-8-3.582-8-8v-8c0-4.418 3.582-8 8-8s8 3.582 8 8v8c0 4.418-3.582 8-8 8z",
    fill: "#faa037"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m136 48h16v-16c0-4.418-3.582-8-8-8-4.418 0-8 3.582-8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m144 88c4.418 0 8-3.582 8-8v-16h-16v16c0 4.418 3.582 8 8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m136 64v-16h-16c-4.418 0-8 3.582-8 8 0 4.418 3.582 8 8 8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m176 56c0-4.418-3.582-8-8-8h-16v16h16c4.418 0 8-3.582 8-8z",
    fill: "#ffd241"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m144 168c-4.418 0-8-3.582-8-8v-48c0-4.418 3.582-8 8-8s8 3.582 8 8v48c0 4.418-3.582 8-8 8z",
    fill: "#faa037"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m144 200c-4.418 0-8-3.582-8-8v-8c0-4.418 3.582-8 8-8s8 3.582 8 8v8c0 4.418-3.582 8-8 8z",
    fill: "#faa037"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 96,
    fill: "#faa037",
    r: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 96,
    fill: "#faa037",
    r: 16
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProductLauch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product-lauch.f3e4816e.svg";
export { ForwardRef as ReactComponent };